// extracted by mini-css-extract-plugin
export default {"block":"Block-module__block--t_prh"};